<template>
  <td
    class="pa-0 overview-block"
    :class="{ 'overview-product-type-cell': productType }"
    :style="productTypeCssVars"
    style="min-width: 160px; max-width: 160px; vertical-align: top"
  >
    <v-col class="pa-0" style="height: 100%">
      <div
        v-for="supplier in suppliers"
        :key="supplier.key"
        align-self="top"
        class="pa-2 text-truncate"
      >
        <QuoteOverviewSupplierBlock :supplier="supplier" />
      </div>
    </v-col>
  </td>
</template>

<script>
import QuoteOverviewSupplierBlock from "./_QuoteOverviewSupplierBlock";
import { getQuoteProductTypeCssVars } from "@/modules/quotes/components/quoteProductTypeColors";

export default {
  props: {
    suppliers: Array,
    productType: {
      type: String,
      default: null,
    },
  },
  components: {
    QuoteOverviewSupplierBlock,
  },
  computed: {
    productTypeCssVars() {
      return this.productType ? getQuoteProductTypeCssVars(this.productType) : null;
    },
  },
};</script>
